(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["pixi"] = factory();
	else
		root["hydux"] = root["hydux"] || {}, root["hydux"]["pixi"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function h(name, attrs) {
    var children = [];
    var rest = [];
    var len = arguments.length;
    while (len-- > 2)
        rest.push(arguments[len]);
    while (rest.length) {
        var child = rest.pop();
        if (exports.Is.array(child)) {
            if (exports.Is.array(child[0])) {
                for (var len_1 = child.length; len_1--;) {
                    rest.push(child[len_1]);
                }
            }
            else if (child.length === 3) {
                children.push(child);
            }
        }
    }
    return [name, attrs, children];
}
exports.h = h;
/**
 * RawObjectWrapper is used for wrap raw pixi objects,
 * we only use it as class.prototype in diff function,
 * the constructor/class field won't work.
 */
var NativeWrapper = /** @class */ (function () {
    function NativeWrapper() {
    }
    NativeWrapper.prototype.updateAll = function (node, attrs) {
        for (var key in attrs) {
            if (typeof attrs[key] === 'undefined' ||
                key[0] === 'onupdate' ||
                key[0] === 'oncreate') {
                continue;
            }
            this.update(node, key, attrs[key], attrs);
        }
    };
    return NativeWrapper;
}());
exports.NativeWrapper = NativeWrapper;
var CompKey = '@gl-vdom/comp';
var Component = /** @class */ (function () {
    function Component(props) {
        this.props = {};
        this.state = {};
        this._rafId = 0;
        this._lastUpdate = 0;
        this.props = props;
    }
    Component.prototype.shouldUpdate = function (nextProps, nextState) {
        return true;
    };
    Component.prototype.updateState = function () {
        this.setState();
    };
    Component.prototype.setState = function (state, cb) {
        var _this = this;
        if (!this.shouldUpdate(this.props, tslib_1.__assign({}, this.state, state))) {
            return;
        }
        if (Date.now() - this._lastUpdate >= 16) {
            this.setStateImmdiately(state, cb);
            return;
        }
        if (this._rafId) {
            cancelAnimationFrame(this._rafId);
        }
        requestAnimationFrame(function () {
            _this.setStateImmdiately(state, cb);
        });
    };
    Component.prototype.setStateImmdiately = function (state, cb) {
        if (exports.Is.def(state)) {
            if (exports.Is.fn(state)) {
                state = state(this.state);
            }
            for (var key in state) {
                this.state[key] = state[key];
            }
        }
        this.forceUpdate();
        exports.Is.def(cb) && cb();
        this._lastUpdate = Date.now();
    };
    Component.prototype.forceUpdate = function () {
        var view = this.render();
        if (view != null && typeof (view) !== 'boolean') {
            patch(this.container, 0, view, this._api);
        }
    };
    Component.prototype.onDidMount = function () {
        // ignore
    };
    Component.prototype.onWillUnmount = function () {
        // ignore
    };
    Component.prototype.render = function () {
        return null;
    };
    return Component;
}());
exports.Component = Component;
exports.Is = {
    array: function (v) {
        return v && v.pop;
    },
    fn: function (v) {
        return typeof v === 'function';
    },
    str: function (v) {
        return typeof v === 'string';
    },
    def: function (v) {
        return typeof v !== 'undefined';
    },
};
function createElement(vnode) {
    var node = vnode[0].prototype.create(vnode[1]);
    var attrs = vnode[1];
    if (attrs && attrs.oncreate) {
        attrs.oncreate(node);
    }
    return node;
}
function mountComponent(parent, i, api) {
    var node = api.getChildAt(parent, i);
    if (exports.Is.def(node) && exports.Is.def(node[CompKey])) {
        try {
            node[CompKey].onDidMount();
        }
        catch (error) {
            console.error(error);
        }
    }
}
function unmountComponent(node, api) {
    if (exports.Is.def(node[CompKey])) {
        try {
            node[CompKey].onWillUnmount();
        }
        catch (error) {
            console.error(error);
        }
    }
    for (var i = 0; i < api.getChildrenCount(node); i++) {
        unmountComponent(api.getChildAt(node, i), api);
    }
}
function update(node, attrs, proto) {
    if (attrs !== null) {
        var onupdate = attrs['onupdate'];
        if (onupdate && onupdate(node, attrs)) {
            return;
        }
        proto.updateAll(node, attrs);
    }
}
function patch(parent, i, vnode, api) {
    var Comp = vnode[0], attrs = vnode[1], children = vnode[2];
    var node = api.getChildAt(parent, i);
    var proto = Comp.prototype;
    var isComponent = false;
    var isCreate = false;
    if (exports.Is.def(proto.getRawClass)) {
        // ignore
    }
    else if (exports.Is.def(proto.getBuiltin)) { // stateful component
        vnode[0] = proto.getBuiltin();
        proto = vnode[0].prototype;
        vnode[1] = attrs = attrs || {};
        attrs['children'] = children;
        isComponent = true;
    }
    else {
        return patch(parent, i, Comp(attrs, children), api);
    }
    if (typeof node === 'undefined') {
        node = createElement(vnode);
        api.addChild(parent, node);
        mountComponent(parent, api.getChildrenCount(parent) - 1, api);
        isCreate = true;
    }
    else {
        var isNotSameNode = node.constructor !== proto.getRawClass();
        var isNotSameComp = (!exports.Is.def(node[CompKey]) && isComponent) ||
            (exports.Is.def(node[CompKey]) && (!isComponent ||
                node[CompKey]).constructor !== Comp);
        if (isNotSameNode || isNotSameComp) {
            node = createElement(vnode);
            unmountComponent(api.getChildAt(parent, i), api);
            api.replaceChildAt(parent, i, node);
            mountComponent(parent, i, api);
            isCreate = true;
        }
    }
    if (!isComponent || !isCreate) {
        update(node, attrs, proto);
    }
    if (!isComponent) {
        patchChildren(node, children, api);
    }
}
exports.patch = patch;
function patchChildren(node, children, api) {
    for (var i = 0; i < children.length; i++) {
        var child = children[i];
        patch(node, i, child, api);
    }
    for (var i = api.getChildrenCount(node) - 1; i >= children.length; i--) {
        unmountComponent(node, api);
        api.removeChildAt(node, i);
    }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Vdom = __webpack_require__(1);
var pixi_1 = __webpack_require__(3);
var React = { createElement: Vdom.h };
exports.React = React;
var h = Vdom.h;
exports.h = h;
var __HYDUX_RENDER_NODE__ = '__HYDUX_RENDER_NODE__';
function withPixi(container, options) {
    if (options === void 0) { options = {}; }
    var rafId;
    var _options = tslib_1.__assign({}, options);
    return function (app) { return function (props) { return app(tslib_1.__assign({}, props, { view: function (s, a) {
            return [props.view, s, a];
        }, onRender: function (view) {
            props.onRender && props.onRender(view);
            if (rafId) {
                window.cancelAnimationFrame(rafId);
            }
            // fix duplicate node in hmr
            var render = function () {
                if (typeof options.stats !== 'undefined') {
                    options.stats.begin();
                    pixi_1.render(container, view[0](view[1], view[2]));
                    options.stats.end();
                }
                else {
                    pixi_1.render(container, view[0](view[1], view[2]));
                }
            };
            rafId = window.requestAnimationFrame(render);
        } })); }; };
}
exports.default = withPixi;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(1);
var CompKey = '@gl-vdom/comp';
function makeComponentRoot(CompClass) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(PIXIComponentRoot, _super);
        function PIXIComponentRoot() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PIXIComponentRoot.prototype.getRawClass = function () { return PIXI.Container; };
        PIXIComponentRoot.prototype.update = function (node, key, val, props) {
            node[CompKey].props[key] = val;
        };
        PIXIComponentRoot.prototype.updateAll = function (node, props) {
            var comp = node[CompKey];
            if (!comp.shouldUpdate(props, comp.state)) {
                return;
            }
            comp.props = props;
            comp.forceUpdate();
        };
        PIXIComponentRoot.prototype.create = function (props) {
            var comp = new CompClass(props);
            var el = new PIXI.Container();
            el[CompKey] = comp;
            comp.container = el;
            comp.forceUpdate();
            return el;
        };
        return PIXIComponentRoot;
    }(_1.NativeWrapper));
}
var PIXIComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PIXIComponent, _super);
    function PIXIComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._api = exports.api;
        return _this;
    }
    PIXIComponent.prototype.getBuiltin = function () {
        if (!this._builtin) {
            this._builtin = makeComponentRoot(this.constructor);
        }
        return this._builtin;
    };
    return PIXIComponent;
}(_1.Component));
exports.PIXIComponent = PIXIComponent;
exports.api = {
    getChildAt: function (parent, i) {
        return parent.children[i];
    },
    getChildrenCount: function (parent) {
        return parent.children.length;
    },
    replaceChildAt: function (parent, i, node) {
        parent.removeChildAt(i);
        parent.addChildAt(node, i);
    },
    removeChildAt: function (parent, i) {
        parent.removeChildAt(i);
    },
    addChild: function (parent, node) {
        parent.addChild(node);
    }
};
function render(parent, vnode) {
    return _1.patch(parent, 0, vnode, exports.api);
}
exports.render = render;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// hydux.pixi.js